import { render, staticRenderFns } from "./SFTPFilesFile.vue?vue&type=template&id=13422954&scoped=true&"
import script from "./SFTPFilesFile.vue?vue&type=script&lang=js&"
export * from "./SFTPFilesFile.vue?vue&type=script&lang=js&"
import style0 from "./SFTPFilesFile.vue?vue&type=style&index=0&id=13422954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13422954",
  null
  
)

export default component.exports